import { useMemo } from 'react';

import { useIsMobile } from '@hooks/use-is-mobile';

import { usePermissions } from 'features/permissions';
import { useStore } from 'models/Provider';

export const useJobTabs = (job) => {
  const { t } = useStore();
  const isMobile = useIsMobile();
  const { hasRolePermission } = usePermissions();

  return useMemo(() => {
    if (isMobile) {
      return [
        { display: t('job.tabs.pipeline'), value: 'pipeline', link: job.pipelineUrl },
        { display: t('job.tabs.applicants'), value: 'list', link: job.applicantsUrl },
        hasRolePermission('job:statistics') && {
          display: t('job.tabs.statistics'),
          value: 'statistics',
          link: job.statisticsUrl,
        },
      ].filter(Boolean);
    }
    return [
      { display: t('job.tabs.pipeline'), value: 'pipeline', link: job.pipelineUrl },
      { display: t('job.tabs.applicants'), value: 'list', link: job.applicantsUrl },
      { display: t('job.tabs.info'), value: 'info', link: job.jobInfoUrl },
      hasRolePermission('job:access') && {
        display: t('job.tabs.access'),
        value: 'access',
        link: job.accessUrl,
      },
      hasRolePermission('job:statistics') && {
        display: t('job.tabs.statistics'),
        value: 'statistics',
        link: job.statisticsUrl,
      },
      hasRolePermission('job:apps') && {
        display: t('job.tabs.integrations'),
        value: 'integrations',
        link: job.integrationsUrl,
      },
      hasRolePermission('job:promote') && {
        display: t('job.tabs.promote'),
        value: 'promote',
        link: job.promoteUrl,
      },
    ].filter(Boolean);
  }, [t, job, isMobile, hasRolePermission]);
};
